/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddendumUIDTOV0 } from './addendumUIDTOV0';
import { AddressDto } from './addressDto';
import { SapImprovementMeasureCodeUIDTOV0 } from './sapImprovementMeasureCodeUIDTOV0';


export interface RdSAPGeneralDetailUIDTOV0 { 
    address: AddressDto;
    /**
     * The type of property as described in the report.
     */
    propertyType?: string;
    /**
     * The built form or detachment type of the property
     */
    builtForm?: string;
    /**
     * The type of measurements used for the property [FIXME `measurementsType` should be used].
     */
    measurements?: string;
    terrain?: string;
    /**
     * Description of the building configuration, including extensions. [DEPRECATED - DG does not know what this is `should it be the extensionCount?`]
     */
    buildingConfiguration?: string;
    /**
     * The count of habitable rooms.
     */
    habitableRoomCount?: number;
    /**
     * The count of heated rooms.
     */
    heatedRoomCount?: number;
    /**
     * The total count of fixed lighting outlets.
     */
    totalFixedLightOutlets?: number;
    /**
     * The total count of fixed low-energy lighting outlets.
     */
    totalFixedLELOutlets?: number;
    /**
     * Description or percentage of low-energy lighting. [TODO  should be int – schema defines a percentage as an int value min 0 max 100]
     */
    lowEnergyLighting?: number;
    /**
     * The type of flat, if applicable. [DEPRECATED All flat details should be stored in array to match xml schema]
     */
    flatType?: string;
    /**
     * The location of the flat within the block, if applicable. [DEPRECATED All flat details should be stored in array to match xml schema]
     */
    locationInBlock?: string;
    /**
     * The number of Storeys in the Apartment Block.
     */
    storeyCount?: string;
    /**
     * The type of corridor leading to the flat, if applicable. [DEPRECATED All flat details should be stored in array to match xml schema]
     */
    corridorType?: string;
    /**
     * The length of the unheated corridor, if applicable.
     */
    unheatedCorridorLength?: number;
    /**
     * The type of conservatory, if applicable. [DEPRECATED All conservatory should be stored in array to match xml schema]
     */
    conservationType?: string;
    /**
     * Whether the conservatory is double-glazed.  [DEPRECATED All conservatory should be stored in array to match xml schema]
     */
    doubleGlazed?: boolean;
    /**
     * The floor area of the conservatory, if applicable.  [DEPRECATED All conservatory should be stored in array to match xml schema]
     */
    floorArea?: number;
    /**
     * The glazed perimeter of the conservatory, if applicable.  [DEPRECATED All conservatory should be stored in array to match xml schema]
     */
    glazedPerimiter?: number;
    /**
     * The height of the conservatory.  [DEPRECATED All conservatory should be stored in array to match xml schema]
     */
    conservatoryHeight?: string;
    /**
     * The type of transaction for the property.
     */
    transactionType?: string;
    /**
     * The tenure type of the property.
     */
    tenure?: string;
    /**
     * Confirm a check for the existence of an EPC before carrying out another energy assessment. 
     */
    previousEpcCheckedCode?: RdSAPGeneralDetailUIDTOV0.PreviousEpcCheckedCodeEnum;
    /**
     * Does an EPC exist at the point of carrying out this energy assessment. 
     */
    previousEpcExistsCode?: RdSAPGeneralDetailUIDTOV0.PreviousEpcExistsCodeEnum;
    /**
     * Reason for not using a previous RdSAP EPC. 
     */
    previousEpcReasonCode?: RdSAPGeneralDetailUIDTOV0.PreviousEpcReasonCodeEnum;
    /**
     * A list of deselected improvement measures. 
     */
    deselectedImprovementMeasures?: Array<SapImprovementMeasureCodeUIDTOV0>;
    /**
     * The numerical identifier of the building part.
     */
    heatLossBuilding?: number;
    addendum?: AddendumUIDTOV0;
}
export namespace RdSAPGeneralDetailUIDTOV0 {
    export type PreviousEpcCheckedCodeEnum = 'Y' | 'NR';
    export const PreviousEpcCheckedCodeEnum = {
        Y: 'Y' as PreviousEpcCheckedCodeEnum,
        Nr: 'NR' as PreviousEpcCheckedCodeEnum
    };
    export type PreviousEpcExistsCodeEnum = 'Y' | 'N' | 'NR';
    export const PreviousEpcExistsCodeEnum = {
        Y: 'Y' as PreviousEpcExistsCodeEnum,
        N: 'N' as PreviousEpcExistsCodeEnum,
        Nr: 'NR' as PreviousEpcExistsCodeEnum
    };
    export type PreviousEpcReasonCodeEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | '13' | '14' | '15';
    export const PreviousEpcReasonCodeEnum = {
        _1: '1' as PreviousEpcReasonCodeEnum,
        _2: '2' as PreviousEpcReasonCodeEnum,
        _3: '3' as PreviousEpcReasonCodeEnum,
        _4: '4' as PreviousEpcReasonCodeEnum,
        _5: '5' as PreviousEpcReasonCodeEnum,
        _6: '6' as PreviousEpcReasonCodeEnum,
        _7: '7' as PreviousEpcReasonCodeEnum,
        _8: '8' as PreviousEpcReasonCodeEnum,
        _9: '9' as PreviousEpcReasonCodeEnum,
        _10: '10' as PreviousEpcReasonCodeEnum,
        _11: '11' as PreviousEpcReasonCodeEnum,
        _12: '12' as PreviousEpcReasonCodeEnum,
        _13: '13' as PreviousEpcReasonCodeEnum,
        _14: '14' as PreviousEpcReasonCodeEnum,
        _15: '15' as PreviousEpcReasonCodeEnum
    };
}


